<template>
  <div class="container">
    <!-- 头图 -->
    <div class="headerBg">
      <v-header></v-header>
    </div>

    <div class="main">
      <v-main />
    </div>

  </div>
</template>

<script>
import vHeader from "../view/header.vue";
import vMain from "../view/main.vue";

export default {
  name: "Index",
  components: {
    vHeader,
    vMain
  }
};
</script>

<style lang="scss" scoped>
.container{
   background-color: #FFFFFF;
  //background: url("~@/assets/jdYear/pc/big_bg.png");
  width: 100%;
  height: 100%;
}
</style>